// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://twdotbqhpcrvdfrvyqty.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3ZG90YnFocGNydmRmcnZ5cXR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDAxNzEwNzQsImV4cCI6MjAxNTc0NzA3NH0.0wXhcoNMXOD3aUatGNvPZ4yTZGbdsJTdirDjEXjBh28';
export const supabase = createClient(supabaseUrl, supabaseKey);
